import React from "react";

function Minus({ width = 20, height = 20, fill = "currentColor" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 13H5V11H19V13Z" fill={fill} />
    </svg>
  );
}

export default Minus;
